import {ShareableType} from './resource-name';

export const BD_RESOURCE_RELATIONSHIPS: {
  [resourceName in ShareableType]?: {
    parents?: ShareableType[];
    children?: ShareableType[];
  };
} = {
  [ShareableType.VIRTUAL_CLINIC_ANALYSIS_DASHBOARD]: {
    children: [ShareableType.CODE_SPECTRUM, ShareableType.VIRTUAL_CLINIC],
  },
  [ShareableType.CODE_SPECTRUM]: {
    parents: [ShareableType.VIRTUAL_CLINIC_ANALYSIS_DASHBOARD],
  },
  [ShareableType.VIRTUAL_CLINIC]: {
    parents: [ShareableType.VIRTUAL_CLINIC_ANALYSIS_DASHBOARD],
  },
  [ShareableType.COMPETITOR_ANALYSIS]: {
    children: [
      ShareableType.CODE_SPECTRUM,
      ShareableType.CLINICS_FILTER,
      ShareableType.VIRTUAL_CLINIC,
    ],
  },
  [ShareableType.POTENTIAL_ANALYSIS]: {
    children: [ShareableType.MARKET, ShareableType.VIRTUAL_CLINIC],
  },
  [ShareableType.MARKET_PROJECTION]: {
    children: [ShareableType.MARKET],
  },
  [ShareableType.BUSINESS_CASE]: {
    children: [ShareableType.MARKET],
  },
};
